import React from 'react';
import { ReactTemplate } from '@bingads-webui-react/react-template';
import { DefaultButton } from '@fluentui/react/lib/Button';
import { tutorStepPropTypes } from './step-component-props';
import { StyledInstructions } from './instructions';
import validateYourUETTag from '../../media/validateYourUETTag.png';

export const ValidateUETTag = (props) => {
  const { i18n } = props;
  const text = i18n.getString(_TL_('It may take up to 24 hours to verify your UET tag. You can check your tag status and if conversion goals are setup correctly now by installing the UET Tag Helper browser extension.'));
  const downloadText = i18n.getString(_TL_('Download the UET tag helper extension'));
  const edgeExtURL = 'https://microsoftedge.microsoft.com/addons/detail/uet-tag-helper-by-micros/nmcihgehpmokipeigjpeckphhdejjpbf';
  const chromeExtURL = 'https://chrome.google.com/webstore/detail/uet-tag-helper-by-bing-ad/naijndjklgmffmpembnkfbcjbognokbf';

  const content = (
    <p>
      <ReactTemplate template={text} />
    </p>
  );

  const validationButtons = (
    <div style={{ display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap' }}>
      <div><DefaultButton style={{ display: 'inline-block', width: '100%' }} text={i18n.getString(_TL_('Microsoft Edge'))} onClick={() => window.open(edgeExtURL)} /></div>
      <div><DefaultButton style={{ display: 'inline-block', width: '100%' }} text={i18n.getString(_TL_('Google Chrome'))} onClick={() => window.open(chromeExtURL)} /></div>
    </div>
  );

  return (
    <React.Fragment>
      <StyledInstructions
        title={i18n.getString(_TL_('Validate your UET tag'))}
        imageSrc={validateYourUETTag}
        descTemp={content}
        downloadInstructions={downloadText}
        button={validationButtons}
        i18n={i18n}
      />
    </React.Fragment>
  );
};

ValidateUETTag.propTypes = tutorStepPropTypes;
